import React from 'react'
import styled, { css } from 'styled-components'

import { color, radius, spacing } from '../../themes'

export type Variant = 'primary' | 'default' | 'secondary'
export type Layout = 'vertical' | 'horizontal' | 'horizontal-embedded'

interface ContainerProps {
  variant: Variant
  layout: Layout
  raised: boolean
  maxWidth?: number
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const variantStyles = (props: ContainerProps) => {
  switch (props.variant) {
    default:
    case 'default':
      return css`
        border: 1px solid ${color('gray.03')};
      `

    case 'primary':
      return css`
        border: 1px solid ${color('blue.01')};
      `

    case 'secondary':
      return css`
        border: 1px solid ${color('gray.04')};
      `
  }
}

const layoutStyles = (props: ContainerProps) => {
  switch (props.layout) {
    default:
    case 'vertical':
      return css``

    case 'horizontal':
      return css`
        display: flex;
        padding: ${spacing(3)};
      `

    case 'horizontal-embedded':
      return css`
        display: flex;
        padding: 0;
        border: 0;
        border-radius: 0;
      `
  }
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  border-radius: ${radius('md')};
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  background-color: ${color('white')};

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}

  ${variantStyles}
  ${layoutStyles}

  ${({ raised }) =>
    raised &&
    css`
      box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.12);
    `}

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth}px;
    `}
`
